// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__Genre from "./genre.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.artist;
  const v$1 = x.artistId;
  const v$2 = x.coverArt;
  const v$3 = x.duration;
  const v$4 = x.genre;
  const v$5 = x.genres;
  const v$6 = x.id;
  const v$7 = x.musicBrainzId;
  const v$8 = x.name;
  const v$9 = x.songCount;
  const v$10 = x.starred;
  const v$11 = x.userRating;
  const v$12 = x.year;
  return {
    artist: v !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"artist\""),
    artistId: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"artistId\""),
    coverArt: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$2) : Ppx_deriving_json_runtime.of_json_error("missing field \"coverArt\""),
    duration: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.float_of_json, v$3) : undefined,
    genre: v$4 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$4) : undefined,
    genres: v$5 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json((function (param) {
        return Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__Genre.of_json, param);
      }), v$5) : undefined,
    id: v$6 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$6) : Ppx_deriving_json_runtime.of_json_error("missing field \"id\""),
    musicBrainzId: v$7 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$7) : undefined,
    name: v$8 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$8) : Ppx_deriving_json_runtime.of_json_error("missing field \"name\""),
    songCount: v$9 !== undefined ? Ppx_deriving_json_runtime.Primitives.int_of_json(v$9) : Ppx_deriving_json_runtime.of_json_error("missing field \"songCount\""),
    starred: v$10 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$10) : undefined,
    userRating: v$11 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$11) : undefined,
    year: v$12 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.int_of_json, v$12) : undefined
  };
}

function to_json(x) {
  return {
    artist: x.artist,
    artistId: x.artistId,
    coverArt: x.coverArt,
    duration: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.duration),
    genre: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.genre),
    genres: Ppx_deriving_json_runtime.Primitives.option_to_json((function (param) {
      return Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__Genre.to_json, param);
    }), x.genres),
    id: x.id,
    musicBrainzId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.musicBrainzId),
    name: x.name,
    songCount: x.songCount,
    starred: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.starred),
    userRating: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.userRating),
    year: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.year)
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
